import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "micro_video",
  "use": "micro_video-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"micro_video\"><path fill-rule=\"evenodd\" d=\"M0 5c0-2.761 2.244-5 5-5 2.761 0 5 2.244 5 5 0 2.761-2.244 5-5 5-2.761 0-5-2.244-5-5Zm8 0L3 8V2l5 3Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol